export const createReferredAdapter = (referreds) => {
    return referreds.map((referred) => ({
        partnerId: referred.partner_id,
        name: referred.name,
        email: referred.email,
        createDate: referred.create_date,
        stage: referred.stage,
    }))
}